module.exports = __webpack_public_path__ + "tajikistan.svg?2c10db83700357c602ee4a8ae1e331c1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/tajikistan.svg
// module id = 314
// module chunks = 10